import React from 'react';
import { Chip } from '@material-ui/core';
import { tint } from '../colors';

const Badge = ({ label, color, style }) => (
  <Chip
    size="small"
    label={label}
    style={{
      backgroundColor: tint(color),
      color,
      fontWeight: 600,
      fontSize: 12,
      height: 24,
      borderRadius: 12,
      ...style,
    }}
  />
);

export default Badge;
